export default "__VITE_ASSET__COWDqP6W__"